import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange", "filterType", "filterSource", "isDisabled", "smartValue", "allOptions", "collabGraphSessionId", "variant"];
import React, { useCallback } from 'react';
import { FilterItem } from '@atlassian/search-dialog';
import { useAnalytics, onFilterSelect, onFilterUnselect, selectEvent } from '../analytics';
export var ProductFilterItem = function ProductFilterItem(_ref) {
  var onChange = _ref.onChange,
    filterType = _ref.filterType,
    filterSource = _ref.filterSource,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    smartValue = _ref.smartValue,
    allOptions = _ref.allOptions,
    _ref$collabGraphSessi = _ref.collabGraphSessionId,
    collabGraphSessionId = _ref$collabGraphSessi === void 0 ? '' : _ref$collabGraphSessi,
    variant = _ref.variant,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useAnalytics = useAnalytics(),
    fireAnalyticsEvent = _useAnalytics.fireAnalyticsEvent;
  var onChangeCallback = useCallback(function (id, checked) {
    if (checked) {
      fireAnalyticsEvent(onFilterSelect({
        filterId: id,
        filterSource: filterSource,
        filterType: filterType
      }));
      if (smartValue && allOptions) {
        fireAnalyticsEvent(selectEvent(smartValue, allOptions, 'quickSearch', collabGraphSessionId));
      }
    } else {
      fireAnalyticsEvent(onFilterUnselect({
        filterId: id,
        filterSource: filterSource,
        filterType: filterType
      }));
    }
    onChange === null || onChange === void 0 || onChange(id, filterType, checked);
  }, [onChange, filterType, fireAnalyticsEvent, filterSource, smartValue, allOptions, collabGraphSessionId]);
  return /*#__PURE__*/React.createElement(FilterItem, _extends({}, rest, {
    onChange: onChangeCallback,
    isDisabled: isDisabled,
    variant: variant
  }));
};